import { styled } from 'parkdepot-shared/theme'

export const ButtonContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: $theme.sizing.scale600,
    marginTop: $theme.sizing.scale700
}))

export const ValidUntilTime = styled('span', ({ $theme }) => ({
    fontWeight: 700
}))
